// import hooks
import i18n from 'config/i18n';
import * as yup from 'yup';

// import utils
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

export const schema = yup.object({
  code: yup
    .string()
    .required(
      t('validationFieldRequired', { name: t('functions.fields.code') })
    ),
  description: yup
    .string()
    .required(
      t('validationFieldRequired', { name: t('functions.fields.description') })
    ),
  valid: yup.object({
    from: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validFrom') }))
      .nullable()
      .default(null),
    to: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validTo') }))
      .nullable()
      .default(null)
      .min(
        yup.ref<Date>('from'),
        t('functions.fields.errors.validTo', {
          from: t('validFrom'),
          to: t('validTo')
        })
      )
  })
});
